// general mutations
export const SET_AUTH_TOKEN = (state, token) => { state.authToken = token }
export const SET_CURRENCY = (state, currency) => { state.currency = currency }
